var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Edit target in databank",
                label: "Update",
                description:
                  "Editing the target will only modify the information within the databank. Any changes made will not affect the target already added to the client.",
                submitLoading: _vm.submitLoading,
                disabled: _vm.isDisabledSubmit,
                maxWidth: "48rem"
              },
              on: {
                "backdrop-close": _vm.onCancel,
                "backdrop-action": _vm.onSubmit
              }
            },
            [
              _vm.modalLoading
                ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : _c("div", { staticClass: "relative" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-col gap-5 px-8 overflow-y-auto",
                        style: {
                          width: "48rem",
                          maxHeight: "calc(100vh - 16rem)"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid items-center grid-cols-2 gap-4 py-4 target-details"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-span-2" },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: { text: "Details" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlInputText", {
                              staticClass: "col-span-2",
                              attrs: { input: _vm.nameInput },
                              on: { changed: _vm.inputHandler }
                            }),
                            _vm._v(" "),
                            _c("BlSelectBox", {
                              attrs: {
                                label: "Data collection method",
                                asterisk: "",
                                placeholder: "Select type",
                                options: _vm.typeOptions,
                                disabled: ""
                              },
                              on: {
                                change: function($event) {
                                  _vm.typeInput = $event
                                }
                              },
                              model: {
                                value: _vm.typeInput,
                                callback: function($$v) {
                                  _vm.typeInput = $$v
                                },
                                expression: "typeInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.target
                              ? _c("BlSelectBox", {
                                  attrs: {
                                    label: "Curriculum",
                                    asterisk: "",
                                    search: "",
                                    placeholder: "Select curriculum",
                                    options: [
                                      {
                                        value: _vm.target.curriculum_id,
                                        label: _vm.target.curriculum_name,
                                        prefixColor: _vm.target.curriculum_color
                                      }
                                    ],
                                    fetchProperty: {
                                      url:
                                        "/api/v1/curriculums?sort=name_asc&query=",
                                      dataKey: "curriculums",
                                      countKey: "total_count",
                                      optionKeys: {
                                        value: "id",
                                        label: "name",
                                        prefixColor: "color"
                                      }
                                    },
                                    disabled: _vm.disabledUpdateCurriculum
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.curriculumIdInput = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.curriculumIdInput,
                                    callback: function($$v) {
                                      _vm.curriculumIdInput = $$v
                                    },
                                    expression: "curriculumIdInput"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlInputText", {
                              staticClass: "col-span-2",
                              attrs: { input: _vm.descriptionInput },
                              on: { changed: _vm.inputHandler }
                            }),
                            _vm._v(" "),
                            _vm.typeInput.includes("Pir")
                              ? _c("BlInputText", {
                                  attrs: { input: _vm.intervalInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeInput.includes("Pir")
                              ? _c("BlInputText", {
                                  attrs: { input: _vm.durationInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeInput.includes("Percentage") ||
                            _vm.typeInput.includes("Pir")
                              ? _c("BlInputText", {
                                  attrs: { input: _vm.goalInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeInput.includes("Duration")
                              ? _c("BlInputTime", {
                                  attrs: { input: _vm.timeInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeInput.includes("Frequency")
                              ? _c("BlInputText", {
                                  attrs: { input: _vm.goalFrequencyInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.target.type.includes("Prompting")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col col-span-2 gap-4 pt-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col gap-2" },
                                      [
                                        _c("BlTextSubtitle1", {
                                          attrs: {
                                            text: "Goal and success metric"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.promptingFormatInput === "classic"
                                          ? _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "Mark this target as successful when the client uses a specific prompt at least a certain number of times."
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.promptingFormatInput === "custom"
                                          ? _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "The target passes if the client's score meets the goal you set."
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.promptingFormatInput === "classic"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grid grid-cols-2 gap-4"
                                          },
                                          [
                                            _c("BlSelectBox", {
                                              key:
                                                "success-metric-" +
                                                JSON.stringify(
                                                  _vm.defaultPrompts
                                                ),
                                              attrs: {
                                                label: "Prompt level",
                                                asterisk: "",
                                                placeholder: "Select prompt",
                                                options: _vm.defaultPrompts.map(
                                                  function(i) {
                                                    return {
                                                      value: i.name,
                                                      label: i.name
                                                    }
                                                  }
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.successMetricInput = $event
                                                }
                                              },
                                              model: {
                                                value: _vm.successMetricInput,
                                                callback: function($$v) {
                                                  _vm.successMetricInput = $$v
                                                },
                                                expression: "successMetricInput"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlInputText", {
                                              attrs: {
                                                input: _vm.goalPromptInput
                                              },
                                              on: { changed: _vm.inputHandler }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.promptingFormatInput === "custom"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grid grid-cols-2 gap-4"
                                          },
                                          [
                                            _c("BlInputText", {
                                              attrs: { input: _vm.goalInput },
                                              on: { changed: _vm.inputHandler }
                                            }),
                                            _vm._v(" "),
                                            _c("BlSelectBox", {
                                              attrs: {
                                                label: "Success metric",
                                                asterisk: "",
                                                placeholder:
                                                  "Select success metric",
                                                options:
                                                  _vm.successMetricOptions
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.successMetricInput = $event
                                                }
                                              },
                                              model: {
                                                value: _vm.successMetricInput,
                                                callback: function($$v) {
                                                  _vm.successMetricInput = $$v
                                                },
                                                expression: "successMetricInput"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : !_vm.typeInput.includes("Sbt")
                              ? _c("BlSelectBox", {
                                  attrs: {
                                    label: "Success metric",
                                    asterisk: "",
                                    placeholder: "Select success metric",
                                    options: _vm.successMetricOptions
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.successMetricInput = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.successMetricInput,
                                    callback: function($$v) {
                                      _vm.successMetricInput = $$v
                                    },
                                    expression: "successMetricInput"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeInput.includes("Percentage")
                              ? _c("BlInputText", {
                                  attrs: { input: _vm.trialsInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.typeInput.includes("Percentage")
                          ? _c(
                              "div",
                              {
                                staticClass: "flex flex-col gap-2 py-4 probing"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "pl-2 pr-4",
                                        style: { transform: "scale(1.375)" }
                                      },
                                      [
                                        _c("BlInputToggle", {
                                          attrs: {
                                            checked: _vm.probingEnableInput
                                          },
                                          on: {
                                            changed: function($event) {
                                              _vm.probingEnableInput = !_vm.probingEnableInput
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle1", {
                                      attrs: { text: "Probing" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "Probing can be employed to assess a skill at various stages of the therapy. Activating probing gives you additional option to conduct probes during the session."
                                  }
                                }),
                                _vm._v(" "),
                                _vm.probingEnableInput
                                  ? _c(
                                      "div",
                                      { staticClass: "grid grid-cols-2 gap-4" },
                                      [
                                        _c("BlInputText", {
                                          attrs: {
                                            input: _vm.probingTrialInput
                                          },
                                          on: { changed: _vm.inputHandler }
                                        }),
                                        _vm._v(" "),
                                        _c("BlInputText", {
                                          attrs: {
                                            input: _vm.probingGoalInput
                                          },
                                          on: { changed: _vm.inputHandler }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.typeInput.includes("Sbt")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-2 py-4 action-recommendation"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "p-1 bg-orange-300",
                                        style: { borderRadius: "4px" }
                                      },
                                      [
                                        _c("BlIcon", {
                                          staticClass: "w-5 h-5",
                                          attrs: { icon: "tooltip" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle1", {
                                      attrs: { text: "Action recommendations" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "Get recommendation after the session when client passes certain conditions."
                                  }
                                }),
                                _vm._v(" "),
                                _c("ActionRecommendationInput", {
                                  attrs: {
                                    navigateSuccessMetric: false,
                                    totalSuccess: _vm.totalSuccessInput,
                                    consecutiveSuccess:
                                      _vm.consecutiveSuccessInput
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.onInputActionRecommendation(
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "absolute z-10 left-8 -bottom-14" },
                      [
                        _c("BlInputButton", {
                          attrs: {
                            type: "plain-error",
                            icon: "trash",
                            label: "Delete target"
                          },
                          on: {
                            clicked: function($event) {
                              _vm.deleteOpened = true
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete the target",
                label: "Delete the target",
                type: "error",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap gap-1 px-8" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to delete the target" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: "" + _vm.target.name }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", { attrs: { text: "from the databank." } }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Are you sure you want to proceed? This action is irreversible."
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Please note that deleting it from the databank won't affect the target already added to the user."
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449e180e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449e180e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/databank/EditDatabankModal.vue
// module id = null
// module chunks = 